interface CheckIconProps {
  size?: number;
  color?: string;
}

export function WarningIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 15 15" fill="currentColor">
      <path d="M8.445.609a1 1 0 0 0-1.89 0L.162 12.234A1 1 0 0 0 1.106 13.5h12.788a1 1 0 0 0 .943-1.266L8.445.61Zm-.95 4.141a.5.5 0 0 1 1 0v3.5a.5.5 0 0 1-1 0v-3.5Zm.5 6.5a.625.625 0 1 1 0-1.25.625.625 0 0 1 0 1.25Z" />
    </svg>
  );
}

export function CheckIcon({ size = 20, color = "currentColor" }: CheckIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 15 15" fill={color}>
      <path d="M7.5 0a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm3.354 5.854-4 4a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L6.5 8.793l3.646-3.647a.5.5 0 1 1 .708.708Z" />
    </svg>
  );
}
